module.exports = __webpack_public_path__ + "static/media/ServicePKS.e646779f.jpg";